import { VerifyAuthenticator } from './Base/VerifyAuthenticator';
export class EnrollAuthenticator extends VerifyAuthenticator {
}
EnrollAuthenticator.remediationName = 'enroll-authenticator';
